import { didShowBanner } from 'actions/appAdvertisement';
import { userAgentStringToPlatform } from 'helpers/UserAgentUtils';
import marketplace from 'cfg/marketplace.json';

const createAppAdvertisement = async (store, navObject = window.navigator, marketplaceConfig = marketplace, mockBranch /* for testing */) => {
  const { domain, branchAppKey, nativeApps : { ad, platforms } } = marketplaceConfig;
  const { cookies: { hideBranchAd } } = store.getState();
  const platformName = userAgentStringToPlatform(navObject.userAgent);
  const platformExists = platforms?.[platformName];

  if (ad.enabled && platformExists && !hideBranchAd) {
    // dynamically import branch sdk so we don't bloat vendor bundle and only import when its going to be used
    const branch = mockBranch || (await import('branch-sdk')).default;
    branch.addListener('didShowBanner', () => void store.dispatch(didShowBanner(true)));
    branch.addListener('didCloseBanner', () => void store.dispatch(didShowBanner(false)));
    branch.init(branchAppKey);
    branch.banner({
      icon: require(`../images/${domain}-app-icon.png`),
      title: ad.header.replace('{platform}', platformName),
      description: ad.tagLine.replace('{platform}', platformName),
      showiOS: ad.showiOSBranchAd,
      showiPad: ad.showiOSBranchAd,
      showAndroid: ad.showAndroidBranchAd,
      forgetHide: ad.hideDays,
      downloadAppButtonText: 'Download',
      openAppButtonText: 'Open in app',
      iframe: false,
      showDesktop: false,
      showKindle: false,
      showBlackberry: false,
      showWindowsPhone: false,
      disableHide: false
    });
  }
};
export default createAppAdvertisement;
